import React, { Fragment, useContext, useEffect, useState } from "react";
import propTypes from "prop-types";

import { api, ProductSaleItemHistory, ProductSaleItemHistoryType } from "../../../../logic/api";

import flex from "../../../../styles/flex";
import styles from "./styles";

import { formatCamel } from "../../../../utility/utils";
import { SessionContext } from "../../../../utility/useSession";
import { useDate } from "../../../../utility/useDate";

import { ProgressView } from "../../../../components/notifications/progress/ProgressView";
import { Trans, useTranslation } from "react-i18next";

const ProductHistoryTable: React.FunctionComponent<{
    bookingId: number,
}> = (props) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();
    const [saleItemsHistory, setSaleItemsHistory] = useState<ProductSaleItemHistory[]>([]);
    const { toFormattedDateTimeString } = useDate();

    const getBookingSaleHistory = api.hooks.booking.getProductHistory();

    useEffect(() => {
        getBookingSaleHistory.send(session.current.context, {
            bookingId: props.bookingId
        });
    }, [props.bookingId]);


    useEffect(() => {
        if (getBookingSaleHistory.data != null) {
            setSaleItemsHistory(getBookingSaleHistory.data);
        } else {
            setSaleItemsHistory([]);
        }
    }, [getBookingSaleHistory.data]);


    return <ProgressView status={getBookingSaleHistory.status}>
        {saleItemsHistory.length == 0 ? (
            <div>{t("input.validations.noProductHistory")}</div>
        ) : (
            <div>{saleItemsHistory.map((item, i) => {
                if (session.current.site == null) {
                    return <Fragment key={i}></Fragment>
                }
                const createDate = toFormattedDateTimeString(new Date(item.createDate));

                return <div key={i} style={flex.flexRows}>
                    <div style={flex.flexAuto}><div style={styles.cell}>{createDate}</div></div>
                    <div style={flex.flexFill}>
                        <div style={styles.cell}>

                            <Fragment>
                                <Trans
                                    i18nKey="product.createdBy"
                                    values={{
                                        itemType: `<span>${formatCamel(ProductSaleItemHistoryType[item.type])}</span>`,
                                        description: `<b>${item.desc}</b>`,
                                        firstName: `<b>${item.createdBy.firstName}</b>`,
                                        lastName: `<b>${item.createdBy.lastName}</b>`
                                    }}
                                    components={{
                                        span: <span />,
                                        b: <b />
                                    }}
                                />

                            </Fragment>

                        </div>
                    </div>
                </div>
            })}</div>
        )}
    </ProgressView>
}

ProductHistoryTable.propTypes = {
    bookingId: propTypes.number.isRequired
}

export default ProductHistoryTable;